import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { ActivityTypeRefResponseDto } from './activity-type-ref.response';

/**
 * Réponse pour la prévisualisation d'une activité générée par l'IA
 * Retourne le contenu généré sans créer l'activité en base
 */
export class PreviewActivityWithAIResponseDto {
  @ApiPropertyOptional({
    description: "Titre de l'activité générée",
    example: 'Les fractions - Exercice pratique',
    type: 'string',
  })
  title?: string;

  @ApiPropertyOptional({
    description: "Instructions de l'activité générée",
    example: 'Complétez les exercices suivants sur les fractions',
    type: 'string',
  })
  instructions?: string;

  @ApiProperty({
    description: "Contenu généré de l'activité",
    type: 'object',
    additionalProperties: true,
  })
  content!: unknown;

  @ApiPropertyOptional({
    description:
      "Durée estimée par l'IA (en minutes) pour réaliser l'activité générée",
    example: 10,
    type: 'number',
  })
  estimatedMinutes?: number;

  @ApiProperty({
    description: 'Type d\'activité utilisé pour la génération',
    type: () => ActivityTypeRefResponseDto,
  })
  type!: ActivityTypeRefResponseDto
}

